import React, { Component } from 'react';
import Const from './Const';
import ConstVal from './../Const';
import { connect } from 'react-redux';
import { changeYearDropdow, REDUCER_NAME } from './../reducer';
import { DropDown } from '../../../common/dropdown';
import { formatTextFloat, formatValueBillion } from '../../../helpers/Text';
import './index.scss';
import { I18n } from 'react-redux-i18n';
import { checkZerroInputValuationTool } from '../../../helpers/Text';
import Icon2 from './icon/icon-pen-2';
import HeaderMethod from './common/HeaderMethod';
import CalculateResult from './common/CalculateResult';
import InputError from './common/InputError';
import { parseFloatComma, parseIntComma } from '../helpers';

class FCFE extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowPopup: true,
      estimateStockPrice: '',
      infoError: '',
      code: props.currentSearch.code,

      g1: '',
      g2: '',
      g1IsValidate: true,
      g2IsValidate: true,
      g1Error: '',
      g2Error: '',
    };
    this.validateG1 = this.validateFCFE.bind(this);
    this.growthRateFCFEg1 = React.createRef();
    this.growthRateFCFEg2 = React.createRef();
    this.costOfEquity = React.createRef();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentSearch.code !== this.state.code) {
      this.setState({
        ...this.state,
        code: nextProps.currentSearch.code,
        estimateStockPrice: '',
        g1: '',
        g2: '',
        infoError: '',
      });
    }
  }

  validateFCFE = (
    growthRateFCFEg1,
    growthRateFCFEg2,
    costOfEquity,
    fcfe,
    yearDropDow,
  ) => {
    let infoError = '';
    if (!fcfe) {
      infoError = 'valuation.errorFCFE.currentFreeCte';
      this.setState({ infoError, estimateStockPrice: '' });
    } else if (
      (growthRateFCFEg1.length <= 0 || isNaN(growthRateFCFEg1)) &&
      yearDropDow !== Const.listYearByKey['zero'].key
    ) {
      infoError = 'valuation.errorFCFE.g1Error';
      this.setState({ infoError, estimateStockPrice: '' });
    } else if (growthRateFCFEg2.length <= 0 || isNaN(growthRateFCFEg2)) {
      infoError = 'valuation.errorFCFE.g2Error';
      this.setState({ infoError, estimateStockPrice: '' });
    } else if (!costOfEquity) {
      infoError = 'valuation.errorFCFE.costOfEquityError';
      this.setState({ infoError, estimateStockPrice: '' });
    } else {
      if (growthRateFCFEg2 === costOfEquity) {
        infoError = 'valuation.errorFCFE.g2ErrorSameNumber';
        this.setState({ infoError, estimateStockPrice: '' });
      } else {
        this.setState({ infoError: '' });
      }
    }
    return infoError;
  };

  calculate = () => {
    const { yearDropDow, averageFCFE, valuationStock } = this.props;
    const g1 = parseFloatComma(this.growthRateFCFEg1.current.value); //(%)
    const g2 = parseFloatComma(this.growthRateFCFEg2.current.value); //(%)
    const fcfe = formatValueBillion(valuationStock.rtq180); //Bn VND
    const costOfEquity = averageFCFE; //(%)
    const share = valuationStock.outstandingShare;
    const year = Const.listYearByKey[yearDropDow].value;

    //TODO: check validation
    let infoError = this.validateFCFE(g1, g2, costOfEquity, fcfe, yearDropDow);
    if (infoError !== '') {
      return;
    }
    // calculate FEFE for each year
    let sumPvFcff = 0;
    for (let i = 1; i <= year; i++) {
      const temp =
        (fcfe * Math.pow(1 + g1 / 100, i)) /
        Math.pow(1 + costOfEquity / 100, i);
      sumPvFcff += temp;
    }
    // calculate terminal value
    const terminalValue =
      (fcfe * Math.pow(1 + g1 / 100, year) * (1 + g2 / 100)) /
      (((costOfEquity - g2) / 100) * Math.pow(1 + costOfEquity / 100, year));

    const fcffValuation = terminalValue + sumPvFcff;

    let estimateStockPrice = (fcffValuation * 1000000000) / share;

    let formatEstimateStockPrice = formatTextFloat(estimateStockPrice);

    this.setState({
      estimateStockPrice: formatEstimateStockPrice,
      costOfEquity: checkZerroInputValuationTool(costOfEquity),
    });
  };

  handleInput(e, refInput) {
    const text = e.target.value;
    if (text.length > 8) {
      return;
    }
    if (text.length > 0) {
      let [integer, decimal] = text.split('.');
      if (decimal && decimal.length > 2) {
        return;
      }
      const formattedInteger = formatTextFloat(parseIntComma(integer), 0);
      if (isNaN(parseIntComma(integer))) {
        return;
      }
      if (decimal && isNaN(parseInt(decimal))) {
        return;
      }
      const finalText =
        decimal !== undefined
          ? `${formattedInteger}.${
              decimal !== '' ? parseInt(decimal) : decimal
            }`
          : formattedInteger;
      if (refInput === this.growthRateFCFEg1) {
        this.setState({
          g1: finalText,
        });
      } else {
        this.setState({
          g2: finalText,
        });
      }
    } else {
      if (refInput === this.growthRateFCFEg1) {
        this.setState({ g1IsValidate: true, g1Error: '', g1: e.target.value });
      }
      if (refInput === this.growthRateFCFEg2) {
        this.setState({ g2IsValidate: true, g2Error: '', g2: e.target.value });
      }
    }
  }

  renderCalculatorResult = () => {
    const {
      infoError,
      estimateStockPrice,
      g1IsValidate,
      g2IsValidate,
    } = this.state;

    const isValidate = !g1IsValidate || !g2IsValidate;

    return (
      <CalculateResult
        infoError={infoError}
        estimateStockPrice={estimateStockPrice}
        numOneFirstResult={'valuation.resultFCFE.numOneFirst'}
        numOneLastResult={'valuation.resultFCFE.numOneLast'}
        isValidate={isValidate}
        calculate={this.calculate}
      />
    );
  };

  renderInfoInputWithError = (
    firstText,
    lastText,
    refInput,
    value,
    isValidateDisable,
    validate,
    errorTooltip,
  ) => {
    return (
      <>
        <span>{firstText}</span>
        <div className="wrap-input-error">
          <input
            className="input-method"
            type="text"
            ref={refInput}
            value={value}
            onChange={e => this.handleInput(e, refInput)}
            disabled={isValidateDisable}
          />
          {validate && (
            <InputError message={I18n.t(`valuation.${errorTooltip}`)} />
          )}
        </div>
        <span>{lastText}</span>
      </>
    );
  };

  renderLeftChild = () => {
    const {
      yearDropDow,
      changeYearDropdow,
      averageFCFE,
      valuationStock,
    } = this.props;

    const { g1IsValidate, g2IsValidate } = this.state;
    const numOneFirstFCFE = I18n.t('valuation.methodFCFE.numOneFirst');
    const numOneLastFCFE = I18n.t('valuation.methodFCFE.numOneLast');
    const numTwoFirstFCFE = I18n.t('valuation.methodFCFE.numTwoFirst');
    const numTwoMidFCFE = I18n.t('valuation.methodFCFE.numTwoMid');
    const numTwoLastFCFE = I18n.t('valuation.methodFCFE.numTwoLast');
    const numThreeFirst = I18n.t('valuation.methodFCFE.numThreeFirst');
    const numThreeLast = I18n.t('valuation.methodFCFE.numThreeLast');
    const numFour = I18n.t('valuation.methodFCFE.numFour');

    return (
      <div className="right-method">
        <HeaderMethod
          title={'FCFE'}
          keyRecommend={ConstVal.recommendMethod.fcfe}
          tooltipTitle={I18n.t('valuation.tooltipInfo.fcfe')}
        />

        <div className="after-div-right">
          <span>{numOneFirstFCFE}</span>
          <input
            className="input-method"
            disabled
            value={
              formatTextFloat(formatValueBillion(valuationStock.rtq180)) || ''
            }
          />
          <span>{numOneLastFCFE}</span>
        </div>

        <div className="after-div-right" style={{ marginTop: -6 }}>
          {this.renderInfoInputWithError(
            numTwoFirstFCFE,
            numTwoMidFCFE,
            this.growthRateFCFEg1,
            this.state.g1,
            !g2IsValidate,
            !this.state.g1IsValidate,
            this.state.g1Error,
          )}
          <div className="line-drop">
            <DropDown
              keyTitle="value"
              listKey={Const.listYear}
              listDataByKey={Const.listYearByKey}
              currentKey={yearDropDow}
              change={changeYearDropdow}
              isEditable={false}
            />
          </div>
          <span>{numTwoLastFCFE}</span>
        </div>

        <div className="after-div-right" style={{ marginTop: -6 }}>
          {this.renderInfoInputWithError(
            numThreeFirst,
            numThreeLast,
            this.growthRateFCFEg2,
            this.state.g2,
            !g1IsValidate,
            !this.state.g2IsValidate,
            this.state.g2Error,
          )}
        </div>

        <div className="after-div-right" style={{ display: 'inherit' }}>
          <span>{numFour}</span>
          <input
            className="input-method"
            type="text"
            value={averageFCFE ? formatTextFloat(averageFCFE) : ''}
            disabled
          />
          <div style={{ position: 'relative' }}>
            <Icon2 type={`CostOfEquity`} />
          </div>
          <span style={{ marginLeft: 5 }}>{'%'}</span>
        </div>
      </div>
    );
  };

  render() {
    return (
      <>
        {this.renderLeftChild()}
        {this.renderCalculatorResult()}
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    yearDropDow: state[REDUCER_NAME].yearDropDow,
    currentSearch: state[REDUCER_NAME].currentSearch,
    i18n: state.i18n,
    averageFCFE: state[REDUCER_NAME].averageFCFE,
    valuationStock: state[REDUCER_NAME].valuationStock,
  };
};

const mapDispatchToProps = {
  changeYearDropdow,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FCFE);
